import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import roCommon from "@/locales/ro/common.json";
import enCommon from "@/locales/en/common.json";
import roNav from "@/locales/ro/nav.json";
import enNav from "@/locales/en/nav.json";
import roHome from "@/locales/ro/home.json";
import enHome from "@/locales/en/home.json";
import roMarketing from "@/locales/ro/marketing.json";
import enMarketing from "@/locales/en/marketing.json";
import roAuth from "@/locales/ro/auth.json";
import enAuth from "@/locales/en/auth.json";
import roLegal from "@/locales/ro/legal.json";
import enLegal from "@/locales/en/legal.json";
import roFaq from "@/locales/ro/faq.json";
import enFaq from "@/locales/en/faq.json";
import roMission from "@/locales/ro/mission.json";
import enMission from "@/locales/en/mission.json";
import roPricing from "@/locales/ro/pricing.json";
import enPricing from "@/locales/en/pricing.json";

export const SUPPORTED_LOCALES = ["ro", "en"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "ro";

void i18n.use(initReactI18next).init({
  resources: {
    ro: {
      common: roCommon,
      nav: roNav,
      home: roHome,
      marketing: roMarketing,
      auth: roAuth,
      legal: roLegal,
      faq: roFaq,
      mission: roMission,
      pricing: roPricing,
    },
    en: {
      common: enCommon,
      nav: enNav,
      home: enHome,
      marketing: enMarketing,
      auth: enAuth,
      legal: enLegal,
      faq: enFaq,
      mission: enMission,
      pricing: enPricing,
    },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: "common",
  ns: ["common", "nav", "home", "marketing", "auth", "legal", "faq", "mission", "pricing"],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
